import isEmpty from 'lodash/isEmpty'

import { getPlugin as getTranslationPlugin } from '@i18n/utils'
import {
  PAYMENT_ADVERTISING_TYPES,
  landingPaymentAdvertising,
  productPaymentAdvertising,
} from '@payment'
import { MAX_RATING } from '@reviews/constants'

import translations from '../../components/TrustList/TrustList.translations'

const ratingsItem = ({ ratings }) => {
  const $t = getTranslationPlugin()

  return {
    id: 'reassurance_payment_service_rate',
    icon: 'IconStarOutlined',
    text: $t(translations.paymentServiceAdviceNew, {
      rate: ratings.averageRate,
      maxRate: MAX_RATING,
    }),
  }
}

const aboutUsItemConfig = () => {
  const $t = getTranslationPlugin()

  return {
    id: 'reassurance_payment_page_verified',
    icon: 'IconBadge',
    text: $t(translations.paymentPageVerified),
  }
}

export const paymentAdvertisingResults = ({
  paymentAdvertisingType,
  paymentMethods,
}) => {
  switch (paymentAdvertisingType) {
    case PAYMENT_ADVERTISING_TYPES.LANDING:
      return landingPaymentAdvertising(paymentMethods)

    case PAYMENT_ADVERTISING_TYPES.PRODUCT:
      return productPaymentAdvertising(paymentMethods).advertised

    default:
      return []
  }
}

const paymentWithAdvertising = ({ paymentAdvertisingType, paymentMethods }) => {
  const item = paymentAdvertisingResults({
    paymentAdvertisingType,
    paymentMethods,
  })

  if (isEmpty(item)) return undefined
  const $t = getTranslationPlugin()

  if (item.icon === '/img/payment/methods-v2/card.svg' || !item.icon) {
    item.icon = 'IconPayment'
  }

  return {
    id: 'reassurance_payment_with_advertising',
    text: $t(item.label),
    icon: item.icon,
  }
}

const displayDefaultPaymentItem = ({ ratings }) => {
  const hasGoodReviews = ratings.reviewsCount >= 10 && ratings.averageRate >= 4

  return hasGoodReviews ? ratingsItem({ ratings }) : aboutUsItemConfig()
}

export const paymentItem = ({
  paymentAdvertisingType,
  ratings,
  paymentMethods,
}) => {
  return (
    paymentWithAdvertising({ paymentAdvertisingType, paymentMethods }) ||
    displayDefaultPaymentItem({ ratings })
  )
}
